import React, { useEffect, useState } from "react";
import {
  CompetitorPriceHistory,
  CompetitorMyCompetitor,
  ProductFilterBerand,
  CompetitorPriceGetProdctGhosh,
  CompetitorPackeageFilterCompanyPackeage,
  CompetitorPackeageDeleteCompanyPackeage,
  CompetitorPackeagePackeageToList,
} from "../../Api/Services";
import imgDoc from "../../assets/Icon/icons8-edit-48.png";
import DownIcon from "../../assets/Icon/DownIcon.png";
import UpIcon from "../../assets/Icon/UpIcon.png";
import imgPlus from "../../assets/Icon/pluse.png";
import imgPackage from "../../assets/Icon/icons8-add-properties-48.png";
import imgsync from "../../assets/Icon/icons8-sync-50.png";
import imgconnect from "../../assets/Icon/icons8-connect-64.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import imgDelete from "../../assets/Icon/icons8-remove-100.png";
import { confirmAlert } from "react-confirm-alert";
import { CheckIdentity } from "../../Common/ConvertIdentity";
import InputCus from "../../Component/InputCus/Text/InputCus";

function CompetitorPrice() {
  const [DataCompetitor, setDataCompetitor] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [ActiveItem, setActiveItem] = useState(null);
  const [ActiveCompetitor, setActiveCompetitor] = useState(null);
  const [ActiveDate, setActiveDate] = useState(null);
  const [PriceHistory, setPriceHistory] = useState();
  const [PricePackeageHistory, setPricePackeageHistory] = useState();
  const [brands, setBrands] = useState([]);
  const [SearchName, setSearchName] = useState("");

  const jalaali = require("jalaali-js");
  const navigate = useNavigate();

  const start = async () => {
    try {
      const CompetitorMyCompetitorData = await CompetitorMyCompetitor();
      if (
        CompetitorMyCompetitorData.status &&
        CompetitorMyCompetitorData.status === 200
      ) {
        setDataCompetitor(CompetitorMyCompetitorData.data.data.data);
        const ProductFilterBerandData = await ProductFilterBerand({});
        if (
          ProductFilterBerandData.status &&
          ProductFilterBerandData.status === 200
        ) {
          setBrands(ProductFilterBerandData.data.data.data);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickCompetitor = async (id) => {
    setLoading(true);
    const CompetitorPriceHistoryData = await CompetitorPriceHistory(id);
    if (
      CompetitorPriceHistoryData.status &&
      CompetitorPriceHistoryData.status === 200
    ) {
      setPriceHistory(CompetitorPriceHistoryData.data.data.data);
    }

    const CompetitorPackeageFilterCompanyPackeageData =
      await CompetitorPackeageFilterCompanyPackeage(id);
    if (
      CompetitorPackeageFilterCompanyPackeageData.status &&
      CompetitorPackeageFilterCompanyPackeageData.status === 200
    ) {
      setPricePackeageHistory(
        CompetitorPackeageFilterCompanyPackeageData.data.data.data,
      );

      setLoading(false);
    }
    setActiveCompetitor(id);
  };

  const handleClickDate = async (key) => {
    setActiveDate(ActiveDate === key ? null : key);
  };

  const handleClickItem = (key) => {
    setActiveItem(ActiveItem === key ? null : key);
  };

  useEffect(() => {
    start();
  }, []);

  const Add = (id) => {
    navigate("/Panel/CompetitorPrice/Add/" + id);
  };
  const AddCopy = (id,exc) => {
    navigate("/Panel/CompetitorPrice/AddCopy/" + id+"/"+exc);
  };
  const AddPackeage = (id) => {
    navigate("/Panel/CompetitorPricePackeage/Add/" + id);
  };

  const ConnectGho = (id) => {
    navigate("/Panel/CompetitorPrice/CompetitorConnect/" + id);
  };

  const synicc = async (id) => {
    setLoading(true);
    try {
      const CompetitorPriceGetProdctGhoshData =
        await CompetitorPriceGetProdctGhosh(id);
      if (
        CompetitorPriceGetProdctGhoshData.status &&
        CompetitorPriceGetProdctGhoshData.status === 200
      ) {
        toast.success(" قیمت گذاری با موفقیت انجام شد");
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
      //start();
    }
  };

  const Edite = (id, extraParam) => {
    navigate(`/Panel/CompetitorPrice/Edite/${id}/${extraParam}`);
  };
  const EditePackeage = (id, extraParam) => {
    navigate(`/Panel/CompetitorPricePackeage/Edite/${id}/${extraParam}`);
  };

  const confirmDelete = (e) => {
    confirmAlert({
      title: "حذف  پکیج",
      message: "آیا مطمئن هستید ؟",
      buttons: [
        {
          label: "بله",
          onClick: () => DeleteItem(e),
        },
        {
          label: "خیر",
        },
      ],
    });
  };

  const DeleteItem = async (e) => {
    try {
      setLoading(true);
      console.log(e);
      
      const CompetitorPackeageDeleteCompanyPackeageData =
        await CompetitorPackeageDeleteCompanyPackeage(e);
      if (
        CompetitorPackeageDeleteCompanyPackeageData.status &&
        CompetitorPackeageDeleteCompanyPackeageData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  // const confirmPackeageToList = (e) => {
  //   confirmAlert({
  //     title: "تبدیل پکیج به لیست ",
  //     message: "آیا مطمئن هستید ؟",
  //     buttons: [
  //       {
  //         label: "بله",
  //         onClick: () => PackeageToList(e),
  //       },
  //       {
  //         label: "خیر",
  //       },
  //     ],
  //   });
  // };

  const PackeageToList = async (e) => {
    try {
      setLoading(true);
      const CompetitorPackeagePackeageToListData =
        await CompetitorPackeagePackeageToList(e);
      if (
        CompetitorPackeagePackeageToListData.status &&
        CompetitorPackeagePackeageToListData.status === 200
      ) {
        toast.success("عملیات با موفقیت انجام شد");
        await start();
      }
    } catch (error) {
      console.error("Error during login:", error);
    } finally {
      setLoading(false);
    }
  };

  const groupProducts = (products) => {
    const groups = {};
    products.forEach((p) => {
      const key = [
        p.productProductBerandId,
        p.productProductTypeId,
        p.productProductSeriesId,
        p.productSymbol,
        p.productProductSeriesEndId,
        p.productProductRamId,
        p.productProductRomId,
        p.productProductNetworkId,
        p.productProductCountryId,
        p.productIsInsurance,
      ].join("-");
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(p);
    });
    return Object.values(groups);
  };

  return (
    <div>
      {isLoading && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={isLoading ? "startLoading" : "stateLoading"}>
        <div className="w-100 d-flex justify-content-start align-items-start flex-column element p-5">
          <div className="d-flex">
            <InputCus
              className="m-2"
              type="text"
              name="name"
              id="name"
              text="نام"
              value={SearchName}
              onChange={(e) => {
                setSearchName(e.target.value);
              }}
            />
          </div>
          {DataCompetitor &&
            DataCompetitor.filter((w) =>
              w.name?.toLowerCase?.().includes(SearchName.toLowerCase()),
            ).map((itemCompetitor) => (
              <>
                <div className="w-100 d-flex justify-content-between align-items-center p-3 bg-body-secondary mt-4 border border-2 border-black">
                  <div>
                    <img
                      className="pointer"
                      onClick={() => {
                        Add(itemCompetitor.id);
                      }}
                      src={imgPlus}
                      alt=""
                    />
                    {CheckIdentity("CompetitorPackeage") && (
                      <img
                        className="pointer"
                        onClick={() => {
                          AddPackeage(itemCompetitor.id);
                        }}
                        src={imgPackage}
                        alt=""
                      />
                    )}

                    {itemCompetitor.isAuto && (
                      <>
                        <img
                          className="pointer me-3"
                          onClick={() => ConnectGho(itemCompetitor.id)}
                          src={imgconnect}
                          alt=""
                          width={"35px"}
                        />
                        <img
                          className="pointer me-3"
                          onClick={() => synicc(itemCompetitor.id)}
                          src={imgsync}
                          alt=""
                          width={"35px"}
                        />
                      </>
                    )}
                  </div>
                  <h5>
                    {itemCompetitor.name +
                      " (" +
                      itemCompetitor.competitorCategoryName +
                      ")"}
                  </h5>
                  <img
                    className="pointer"
                    onClick={() => handleClickCompetitor(itemCompetitor.id)}
                    src={
                      ActiveCompetitor === itemCompetitor.id ? UpIcon : DownIcon
                    }
                    alt=""
                  />
                </div>

                {ActiveCompetitor === itemCompetitor.id && (
                  <div className="border border-2 border-black border-top-0 w-100 d-flex justify-content-center flex-column align-items-center p-3">
                    {PriceHistory &&
                      PriceHistory.map((itemDate, keyDate) => (
                        <>
                          <div
                            key={keyDate}
                            className="d-flex justify-content-between align-items-center w-100 mt-3 p-3 bg-body-secondary border border-2 border-black"
                          >
                            <img
                              className="pointer"
                              height="30"
                              src={imgDoc}
                              alt="ویرایش"
                              onClick={() => {
                                Edite(itemCompetitor.id, itemDate.date);
                              }}
                            />
                            <h5>
                              {(() => {
                                const date = new Date(
                                  itemDate.date.replace("T", " "),
                                );
                                const jalaaliDate = jalaali.toJalaali(date);
                                const year = jalaaliDate.jy;
                                const month = jalaaliDate.jm
                                  .toString()
                                  .padStart(2, "0");
                                const day = jalaaliDate.jd
                                  .toString()
                                  .padStart(2, "0");
                                const hours = date
                                  .getHours()
                                  .toString()
                                  .padStart(2, "0");
                                const minutes = date
                                  .getMinutes()
                                  .toString()
                                  .padStart(2, "0");
                                const seconds = date
                                  .getSeconds()
                                  .toString()
                                  .padStart(2, "0");

                                return `${hours}:${minutes}:${seconds} ${year}/${month}/${day}`;
                              })()}
                            </h5>
                            <img
                              className="pointer"
                              src={ActiveDate === keyDate ? UpIcon : DownIcon}
                              alt=""
                              onClick={() => handleClickDate(keyDate)}
                            />
                          </div>
                          {ActiveDate === keyDate && (
                            <div className="d-flex justify-content-center align-items-center flex-column w-100 p-3 pt-3 pb-3 border border-2 border-black border-top-0">
                              {brands.map(
                                (brand, key) =>
                                  itemDate.data.filter(
                                    (e) => e.productProductBerandId == brand.id,
                                  ).length > 0 && (
                                    <>
                                      <div
                                        key={brand.name}
                                        className="d-flex justify-content-around align-items-center w-100 p-3 pointer bg-body-secondary mt-4 border border-2 border-black"
                                        onClick={() =>
                                          handleClickItem(brand.name)
                                        }
                                      >
                                        <h5>{brand.name}</h5>
                                      </div>
                                      {ActiveItem === brand.name && (
                                        <div className="d-flex justify-content-center align-items-center w-100 tableC">
                                          <table className="table tableMore">
                                            <thead className="sticky-header">
                                              <tr className="trTable">
                                                <th>نام محصول</th>
                                                <th>رنگ</th>
                                                <th>قیمت</th>
                                              </tr>
                                            </thead>
                                            {itemDate.data &&
                                              groupProducts(itemDate.data).map(
                                                (group, gIndex) => (
                                                  <tbody key={gIndex}>
                                                    {group
                                                      .filter(
                                                        (w) =>
                                                          w.productProductBerandId ==
                                                          brand.id,
                                                      )
                                                      .map(
                                                        (itemPro, iIndex) => {
                                                          return (
                                                            <tr
                                                              key={itemPro.id}
                                                            >
                                                              {iIndex === 0 && (
                                                                <>
                                                                  <td
                                                                    rowSpan={
                                                                      group.length
                                                                    }
                                                                  >
                                                                    {itemPro.productProductTypeName !=
                                                                      " " &&
                                                                      itemPro.productProductTypeName +
                                                                        " "}
                                                                    {itemPro.productProductSeriesName !=
                                                                      " " &&
                                                                      itemPro.productProductSeriesName}
                                                                    {
                                                                      itemPro.productSymbol
                                                                    }
                                                                    {itemPro.productProductSeriesEndName !=
                                                                    " "
                                                                      ? itemPro.productProductSeriesEndName +
                                                                        " "
                                                                      : " "}
                                                                    {itemPro.productProductRamName !=
                                                                      " " &&
                                                                      itemPro.productProductRamName +
                                                                        "/"}
                                                                    {itemPro.productProductRomName !=
                                                                      " " &&
                                                                      itemPro.productProductRomName +
                                                                        " "}
                                                                    {itemPro.productProductNetworkName !=
                                                                      " " &&
                                                                      itemPro.productProductNetworkName +
                                                                        " "}
                                                                    {itemPro.productProductCountryName !=
                                                                      " " &&
                                                                      itemPro.productProductCountryName +
                                                                        " "}
                                                                    {itemPro.productIsInsurance &&
                                                                      "بیمه"}
                                                                  </td>
                                                                </>
                                                              )}
                                                              <td>
                                                                {
                                                                  itemPro.productProductColorName
                                                                }
                                                              </td>
                                                              <td>
                                                                {itemPro.price
                                                                  .toString()
                                                                  .replace(
                                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                                    ",",
                                                                  )}
                                                              </td>
                                                            </tr>
                                                          );
                                                        },
                                                      )}
                                                  </tbody>
                                                ),
                                              )}
                                          </table>
                                        </div>
                                      )}
                                    </>
                                  ),
                              )}
                            </div>
                          )}
                        </>
                      ))}
                    {PricePackeageHistory &&
                      PricePackeageHistory.map((itemDate, keyDate) => (
                        <>
                          <div
                            key={keyDate + "Packeage"}
                            className="d-flex justify-content-between align-items-center w-100 mt-3 p-3 bg-body-secondary border border-2 border-black"
                          >
                            <div className="d-flex justify-content-center align-items-center">
                              <div className="border border-2 border-black ms-1">
                                <div className="border border-2 border-black m-2">
                                  <img
                                    width={"30px"}
                                    className="pointer"
                                    onClick={() => {
                                      AddCopy(itemCompetitor.id,itemDate.id);
                                    }}
                                    src={imgPlus}
                                    alt=""
                                  />
                                </div>
                              </div>
                              <img
                                className="pointer ms-3"
                                height="30"
                                src={imgDoc}
                                alt="ویرایش"
                                onClick={() => {
                                  EditePackeage(itemCompetitor.id, itemDate.id);
                                }}
                              />
                              <img
                                className="pointer ms-3"
                                height="30"
                                src={imgDelete}
                                alt="حذف"
                                onClick={() => {
                                  confirmDelete(itemDate.id);
                                }}
                              />
                            </div>
                            <h5>{itemDate.title}</h5>
                            <h5>{itemDate.description}</h5>
                            <img
                              className="pointer"
                              src={
                                ActiveDate === keyDate + "Packeage"
                                  ? UpIcon
                                  : DownIcon
                              }
                              alt=""
                              onClick={() =>
                                handleClickDate(keyDate + "Packeage")
                              }
                            />
                          </div>
                          {ActiveDate === keyDate + "Packeage" && (
                            <div className="d-flex justify-content-center align-items-center flex-column w-100 p-3 pt-3 pb-3 border border-2 border-black border-top-0">
                              {brands.map(
                                (brand, key) =>
                                  itemDate.prices.filter(
                                    (e) => e.productProductBerandId == brand.id,
                                  ).length > 0 && (
                                    <>
                                      <div
                                        key={brand.name}
                                        className="d-flex justify-content-around align-items-center w-100 p-3 pointer bg-body-secondary mt-4 border border-2 border-black"
                                        onClick={() =>
                                          handleClickItem(brand.name)
                                        }
                                      >
                                        <h5>{brand.name}</h5>
                                      </div>
                                      {ActiveItem === brand.name && (
                                        <div className="d-flex justify-content-center align-items-center w-100 tableC">
                                          <table className="table tableMore">
                                            <thead className="sticky-header">
                                              <tr className="trTable">
                                                <th>نام محصول</th>
                                                <th>تعداد</th>
                                                <th>قیمت</th>
                                              </tr>
                                            </thead>

                                            {itemDate.prices.filter(
                                              (e) =>
                                                e.productProductBerandId ==
                                                brand.id,
                                            ) &&
                                              groupProducts(
                                                itemDate.prices.filter(
                                                  (e) =>
                                                    e.productProductBerandId ==
                                                    brand.id,
                                                ),
                                              ).map((group, gIndex) => (
                                                <tbody key={gIndex}>
                                                  {group
                                                    .filter(
                                                      (w) =>
                                                        w.productProductBerandId ==
                                                        brand.id,
                                                    )
                                                    .map((itemPro, iIndex) => {
                                                      return (
                                                        <tr key={itemPro.id}>
                                                          {iIndex === 0 && (
                                                            <>
                                                              <td
                                                                rowSpan={
                                                                  group.length
                                                                }
                                                              >
                                                                {itemPro.productProductTypeName !=
                                                                  " " &&
                                                                  itemPro.productProductTypeName +
                                                                    " "}
                                                                {itemPro.productProductSeriesName !=
                                                                  " " &&
                                                                  itemPro.productProductSeriesName}
                                                                {
                                                                  itemPro.productSymbol
                                                                }
                                                                {itemPro.productProductSeriesEndName !=
                                                                " "
                                                                  ? itemPro.productProductSeriesEndName +
                                                                    " "
                                                                  : " "}
                                                                {itemPro.productProductRamName !=
                                                                  " " &&
                                                                  itemPro.productProductRamName +
                                                                    "/"}
                                                                {itemPro.productProductRomName !=
                                                                  " " &&
                                                                  itemPro.productProductRomName +
                                                                    " "}
                                                                {itemPro.productProductNetworkName !=
                                                                  " " &&
                                                                  itemPro.productProductNetworkName +
                                                                    " "}
                                                                {itemPro.productProductCountryName !=
                                                                  " " &&
                                                                  itemPro.productProductCountryName +
                                                                    " "}
                                                                {itemPro.productIsInsurance &&
                                                                  "بیمه"}
                                                              </td>
                                                            </>
                                                          )}

                                                          <td>
                                                            {itemPro.count}
                                                          </td>
                                                          <td>
                                                            {itemPro.price
                                                              .toString()
                                                              .replace(
                                                                /\B(?=(\d{3})+(?!\d))/g,
                                                                ",",
                                                              )}
                                                          </td>
                                                        </tr>
                                                      );
                                                    })}
                                                </tbody>
                                              ))}
                                          </table>
                                        </div>
                                      )}
                                    </>
                                  ),
                              )}
                            </div>
                          )}
                        </>
                      ))}
                  </div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  );
}

export default CompetitorPrice;
